import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';

export type IErrorPageProps = Record<string, never>;

export const ErrorPage: React.FC<IErrorPageProps> = () => {
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <title>Error</title>
      </Helmet>

      <div>{t('common.error')}</div>
    </>
  );
};
